<template>
    <div class="HotelDetail" id="HotelDetail" @scroll="scrollContainer">
        <CustomHeader :color="headOptions.color" :bgColor="headOptions.bgColor" :leftText="hotelDetail.hotelName" />
        <div class="swipe-wrap">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" :show-indicators="false">
                <van-swipe-item v-for="(item, index) in hotelDetail.hotelImages" :key="index">
                    <div
                        class="swipeImg bgi noImg"
                        :style="{
                            backgroundImage: `url('${$getImageUrl(item)}')`,
                        }"
                    ></div>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="card-container">
            <div class="hotel-info">
                <div class="infoTop jc-between ai-center">
                    <div class="column1">
                        <div>
                            <span>{{ hotelDetail.hotelName }}</span>
                            <span v-if="hotelDetail.stars == 0">经济型</span>
                            <span v-if="hotelDetail.stars == 1">舒适/三星</span>
                            <span v-if="hotelDetail.stars == 2">高档/四星</span>
                            <span v-if="hotelDetail.stars == 3">豪华/五星</span>
                        </div>
                        <div>
                            <span v-if="hotelDetail.description.decorateTime">{{ hotelDetail.description.decorateTime }}年装修</span>
                            <span v-if="hotelDetail.description.openTime">{{ hotelDetail.description.openTime }}年开业</span>
                            <span v-for="(item, index) in hotelDetail.description.facilityShow" :key="index">
                                <span :class="`fa ${item.icon}`"></span>
                                <span>{{ item.text }}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <!-- <div class="jc-between ai-center" @click="toMap(hotelDetail.hotelAddress)"> -->
                <div class="jc-between ai-center">
                    <span>{{ hotelDetail.hotelAddress }}</span>
                    <!-- <span class="flex-column flex-center">
                        <i class="fa fa-location-arrow fa-lg location flex-center"></i>
                        <span>地图 / 周边</span>
                    </span> -->
                </div>
            </div>
        </div>
        <div class="tab-wrap">
            <van-tabs v-model="activeTab" :color="$primary" swipeable>
                <van-tab title="房型">
                    <div class="date-info jc-between ai-center">
                        <div class="dateArea jc-between ai-center flex-1">
                            <div class="startTime" @click="clickDate('start')">
                                <span>{{ routeQuery.startTime | toNumCNDate }}</span>
                                <span>{{ routeQuery.startTime | toCNWeek }}</span>
                            </div>
                            <div>{{ dataLength }}</div>
                            <div class="endTime" @click="clickDate('end')">
                                <span>{{ routeQuery.endTime | toNumCNDate }}</span>
                                <span>{{ routeQuery.endTime | toCNWeek }}</span>
                            </div>
                        </div>
                        <div @click="showPersonNumPicker = true" class="personNum jc-end">{{ routeQuery.personNum }}人</div>
                    </div>

                    <div class="roomList">
                        <div @click="clickRoomItem(item, index)" class="roomItem jc-between" v-for="(item, index) in roomList" :key="index">
                            <div
                                :style="{
                                    backgroundImage: `url('${$getImageUrl(item.img[0])}')`,
                                }"
                                class="bgi noImg roomImg"
                            ></div>
                            <div class="flex-1 roomInfo flex-column jc-between">
                                <div>{{ item.name }}</div>
                                <div>
                                    <span v-for="(item1, index1) in item.explain" :key="index1" class="mr-1">
                                        <span>{{ item1.content }}</span>
                                    </span>
                                </div>
                                <div class="flex-1 jc-end ai-end width-100">
                                    <div @click.stop="reserveHotel(item)">预订</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="政策 / 设施">
                    <div class="strategyBlock bg-white">
                        <div class="title">政策</div>
                        <div v-html="policy.content"></div>
                    </div>

                    <div class="strategyBlock bg-white">
                        <div class="title">设施</div>
                        <div v-html="facility.content"></div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
        <CustomRoomDetail
            ref="CustomRoomDetail"
            :title="currentRoomDetail.name"
            :swipers="currentRoomDetail.img"
            :facilities="currentRoomDetail.facility"
            :properties="currentRoomDetail.explain"
            :notice="currentRoomDetail.notice"
            :mustRead="currentRoomDetail.mustRead"
            :policy="currentRoomDetail.policy"
        >
            <template #buy>
                <div class="order-wrap">
                    <van-button class="orderBtn" @click="reserveHotel(currentRoomDetail)" color="linear-gradient(90deg,#fde59f,#ebb06c)" block>
                        立即预订
                    </van-button>
                </div>
            </template>
        </CustomRoomDetail>
        <ToTop listId="HotelDetail" />
        <van-popup v-model="showDatePicker" round position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                @cancel="showDatePicker = false"
                @confirm="confirmDate"
                type="date"
                :title="`${dateType == 'start' ? '请选择入住时间' : '请选择离店日期'}`"
                :min-date="minDate"
                :max-date="maxDate"
            />
        </van-popup>
        <van-popup v-model="showPersonNumPicker" round position="bottom" :style="{ height: '50%' }">
            <van-picker
                title="请选择入住人数"
                @cancel="showPersonNumPicker = false"
                @confirm="confirmPersonNumPicker"
                show-toolbar
                :columns="new Array(5).fill(null).map((item, index) => ({ text: index + 1 + '人', value: index + 1 }))"
            />
        </van-popup>
    </div>
</template>
<script>
import { searchParamsKey } from "@/utils/variable";
import { Toast } from "vant";
import { getHotelDetail, getAllHotel, getPolicy, getRoomList, test } from "@/api/hotel";
test().then(res => {
    console.log(res);
});

const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
let initRouteQuery = {
    startTime: today,
    endTime: today + 1000 * 60 * 60 * 24,
    selectedKeyword: "",
    selectedStar: {
        index: -1,
        title: "星级/价格",
    },
    selectedAreaObj: {
        code: null,
        name: "请选择城市",
    },
    fuzzySearch: "",
};
let initHeadOptions = {
    leftText: "",
    color: "#fff",
    bgColor: "transparent",
};
let scrollHeadOptions = {
    leftText: "留住我青旅",
    color: "#333",
    bgColor: "#fff",
};
export default {
    data() {
        return {
            routeQuery: JSON.parse(JSON.stringify(initRouteQuery)),
            headOptions: JSON.parse(JSON.stringify(initHeadOptions)),
            activeTab: 0,
            propertyCollapsed: true,
            showDatePicker: false,
            minDate: new Date(today),
            maxDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365),
            dateType: "start",
            currentDate: new Date(today),
            showPersonNumPicker: false,
            isCollected: false,
            hotelDetail: { description: { facilityShow: [] }, hotelImages: [] },
            policy: {},
            facility: {},
            roomList: [],
            currentRoomDetail: {},
        };
    },
    created() {
        this.routeQuery = localStorage[searchParamsKey] ? JSON.parse(localStorage[searchParamsKey]) : JSON.parse(JSON.stringify(initRouteQuery));
        this.routeQuery.personNum = this.personNum;
        this.getHotelDetail_com();
    },
    watch: {
        activeTab(newV) {
            let tabsWrap = document.getElementsByClassName("van-tabs__wrap")[0];
            if (newV == 1) {
                if (this.hotelDetail.hotelPolicy) {
                    getPolicy({ id: this.hotelDetail.hotelPolicy }).then(res => {
                        if (res.code === 200) {
                            this.policy = res.data;
                        }
                    });
                }
                if (this.hotelDetail.hotelFacility) {
                    getPolicy({ id: this.hotelDetail.hotelFacility }).then(res => {
                        if (res.code === 200) {
                            this.facility = res.data;
                        }
                    });
                }
                tabsWrap.style["borderBottomLeftRadius"] = "2vw";
                tabsWrap.style["borderBottomRightRadius"] = "2vw";
            } else {
                tabsWrap.style["borderBottomLeftRadius"] = "0";
                tabsWrap.style["borderBottomRightRadius"] = "0";
            }
        },
    },
    computed: {
        personNum: {
            set(val) {
                this.routeQuery.personNum = val;
            },
            get() {
                return this.routeQuery.personNum || 1;
            },
        },
        dataLength() {
            return `${Math.floor(
                (new Date(this.routeQuery.endTime).getTime() - new Date(this.routeQuery.startTime).getTime()) / (1000 * 60 * 60 * 24)
            )}晚`;
        },
    },
    methods: {
        getHotelDetail_com() {
            getAllHotel({ id: this.$route.query.id, isLike: "" }).then(res => {
                if (res.code === 200) {
                    let records = res.data.records;
                    if (records.length) {
                        this.hotelDetail = {
                            ...records[0],
                            description: records[0].description
                                ? {
                                      ...JSON.parse(records[0].description),
                                      facilityShow: JSON.parse(records[0].description).facilityShow.map(item => ({
                                          icon: item.split("&name=")[0],
                                          text: item.split("&name=")[1],
                                      })),
                                  }
                                : { facilityShow: [] },
                            hotelImages: records[0].hotelImages ? records[0].hotelImages.split(",") : [],
                        };
                        getRoomList({ hotelId: records[0].id }).then(res => {
                            if (res.code === 200) {
                                this.roomList = res.data.map(item => ({
                                    ...item,
                                    img: item.img.split(","),
                                    explain: item.explain ? JSON.parse(item.explain) : [],
                                    mustRead: item.mustRead ? JSON.parse(item.mustRead) : [],
                                }));
                            }
                        });
                    }
                }
            });
        },
        clickStar() {
            if (this.isCollected) {
                this.isCollected = false;
                this.$Toast.success("已取消收藏");
            } else {
                this.isCollected = true;
                this.$Toast.success("已收藏");
            }
        },
        confirmPersonNumPicker(e) {
            this.routeQuery.personNum = e.value;
            this.showPersonNumPicker = false;
        },
        confirmDate(e) {
            let DateTime = e.getTime();
            if (this.dateType == "start") {
                if (this.routeQuery.endTime - DateTime >= 1000 * 60 * 60 * 24) {
                    this.routeQuery.startTime = DateTime;
                } else {
                    return Toast("开始时间应小于结束时间");
                }
            } else {
                if (DateTime - this.routeQuery.startTime >= 1000 * 60 * 60 * 24) {
                    this.routeQuery.endTime = DateTime;
                } else {
                    return Toast("结束时间应大于开始时间");
                }
            }
            this.showDatePicker = false;
        },
        clickDate(type) {
            this.showDatePicker = true;
            this.dateType = type;
            if (type == "start") {
                this.currentDate = new Date(this.routeQuery.startTime);
            } else {
                this.currentDate = new Date(this.routeQuery.endTime);
            }
        },
        clickRoomItem(roomItem, roomIndex) {
            this.currentRoomDetail = roomItem;
            this.$refs.CustomRoomDetail.open();
        },
        reserveHotel(room) {
            localStorage[searchParamsKey] = JSON.stringify(this.routeQuery);
            this.$router.push({ path: "/confirmOrder", query: { roomId: room.id, hotelId: this.$route.query.id } });
        },
        scrollContainer(e) {
            if (e.target.scrollTop >= 1) {
                this.headOptions = JSON.parse(JSON.stringify(scrollHeadOptions));
            } else {
                this.headOptions = JSON.parse(JSON.stringify(initHeadOptions));
            }
        },
        // toMap(loc) {
        //     location = `${process.env.VUE_APP_LOCATION}${loc}`;
        // },
    },
};
</script>

<style lang="scss" scoped>
.HotelDetail {
    height: 100vh;
    overflow-y: scroll;
    position: relative;
    /deep/.van-hairline--bottom::after {
        border: none;
    }
    .swipeSize {
        width: 100vw;
        height: 75vw;
    }
    .swipe-wrap {
        @extend .swipeSize;
        position: absolute;
        top: 0;
        .my-swipe {
            @extend .swipeSize;
            .swipeImg {
                @extend .swipeSize;
                &:before {
                    @extend .swipeSize;
                    content: "";
                    position: absolute;
                    z-index: 2;
                    background-image: linear-gradient(to bottom, transparent, transparent, rgba(255, 255, 255, 1));
                }
            }
        }
    }
    .card-container {
        padding: 0 2.5vw;
        .hotel-info {
            width: 100%;
            min-height: 38vw;
            border-radius: 2vw;
            background-color: #fff;
            margin: 40vw auto 0;
            position: relative;
            z-index: 3;
            box-shadow: 0 3px 3px rgba($color: #000000, $alpha: 0.1);
            padding: 2.6vw;
            box-sizing: border-box;
            color: #333;
            font-size: 3.3vw;
            .infoTop {
                border-bottom: 1px solid #f3f3f3;
                .column1 {
                    > div:first-child {
                        margin-bottom: 1.5vw;
                        > span:first-child {
                            color: #000;
                            font-weight: bold;
                            font-size: 4.5vw;
                            margin-right: 2vw;
                        }
                    }
                    > div:nth-child(2) {
                        padding-bottom: 1.5vw;
                        span + span {
                            margin-left: 2vw;
                        }
                    }
                }
                .column2 {
                    width: 16vw;
                    height: 16vw;
                }
            }
            > div:last-child {
                &:active {
                    background-color: rgba($color: #ccc, $alpha: 0.1);
                }
                color: rgb(110, 110, 110);
                margin-top: 2vw;
                > span:first-child {
                    flex-grow: 1;
                }
                > span:last-child {
                    flex-shrink: 0;
                    width: 18vw;
                    height: 18vw;
                    .location {
                        color: #333;
                        margin-bottom: 1vw;
                        width: 7vw;
                        height: 7vw;
                        background-color: #e7e7e7;
                        border-radius: 50%;
                    }
                }
            }
        }
    }
    .tab-wrap {
        min-height: calc(100vh - 78vw - 46px);
        background-color: #f7f7f7;
        padding-top: 3vw;
        /deep/.van-tabs__wrap {
            margin: 0 2.5vw 0;
            border-top-left-radius: 2vw;
            border-top-right-radius: 2vw;
        }
        .date-info {
            border-bottom-left-radius: 2vw;
            border-bottom-right-radius: 2vw;
            overflow: hidden;
            background-color: #fff;
            padding: 2.5vw 4vw;
            margin: 0 2.5vw 0;
            font-size: 3.2vw;
            .startTime,
            .endTime,
            .personNum {
                position: relative;
                &:active {
                    &:after {
                        content: "";
                        position: absolute;
                        left: -2vw;
                        right: -2vw;
                        top: -2vw;
                        bottom: -2vw;
                        background-color: rgba($color: #ffe6e6, $alpha: 0.3);
                    }
                }
            }
            .dateArea {
                $dateColor: #b4b4b4;
                padding-right: 4vw;
                border-right: 1px solid $dateColor;
                .startTime > span:first-child,
                .endTime > span:first-child {
                    font-size: 4.1vw;
                    font-weight: bold;
                    margin-right: 1vw;
                }
                > div:nth-child(2) {
                    padding: 0 1.5vw;
                    border-radius: 2.5vw;
                    border: 1px solid $dateColor;
                    position: relative;
                    &:before,
                    &:after {
                        content: "";
                        width: 1.5vw;
                        height: 1px;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        background-color: $dateColor;
                    }
                    &:before {
                        left: -1.5vw;
                    }
                    &:after {
                        right: -1.5vw;
                    }
                }
            }
            .personNum {
                width: 13vw;
                font-weight: bold;
            }
        }
        .roomList {
            padding: 0 2.5vw;
            margin-top: 3vw;
            .roomItem {
                margin-bottom: 1.6vw;
                padding: 2vw;
                border-radius: 2vw;
                overflow: hidden;
                background-color: #fff;
                &:active {
                    background-color: rgba($color: #ccc, $alpha: 0.2);
                }
                .roomImg {
                    border-radius: 2vw;
                    width: 20vw;
                    height: 20vw;
                }
                .roomInfo {
                    padding: 0 2vw;
                    font-size: 3.3vw;
                    > div:first-child {
                        font-weight: bold;
                        font-size: 4vw;
                        margin-bottom: 1.5vw;
                    }
                    > div:nth-child(2) {
                        max-width: 70vw;
                        > span {
                            color: #585858;
                            display: inline-block;
                            padding: 0 1vw;
                            box-sizing: border-box;
                            margin-right: 2vw;
                        }
                    }
                    > div:nth-child(3) {
                        align-self: flex-end;
                        > div {
                            padding: 0.8vw 2.5vw;
                            border-radius: 4vw;
                            /* background-color: #fbe3b3; */
                            background: linear-gradient(90deg, #fde59f, #ebb06c);
                            margin-right: 2vw;
                            font-size: 3.2vw;
                            box-shadow: 0 0 3px rgba($color: #000000, $alpha: 0.1);
                        }
                    }
                }
            }
        }
        .strategyBlock {
            margin: 2vw 2.5vw 0;
            padding: 3.5vw 5.5vw;
            border-radius: 2vw;
            .title {
                font-size: 4.7vw;
                font-weight: bold;
                margin-bottom: 2vw;
            }
            .strategyIcon {
                color: #6e6e6e;
                font-size: 4.2vw;
            }
            .strategyItem {
                width: 50%;
                margin-bottom: 2vw;
                > span:last-child {
                    color: #333;
                }
            }
        }
    }
    .order-wrap {
        position: relative;
        bottom: 0;
        height: 16vw;
        .orderBtn {
            position: fixed;
            bottom: 0;
            width: 94vw;
            margin: 3vw;
            border-radius: 6vw;
        }
    }
}
</style>
